import { assistantPageCodeEnum } from "features/AssistantPages/constantTypes";

export const formatPageName = (value?: assistantPageCodeEnum | null) => {
  if (!value) return "";

  return value
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};
